import { Button, PaletteColorOptions, styled } from '@mui/material'
import {
  FOOTER_ACTION_BUTTON_HEIGHT,
  SEND_FIELD_BORDER_TOP_COLOR,
} from '$comp/_app/components/chat/components/conf'

interface Props {
  backgroundColor: PaletteColorOptions
}
export const ACTION_BUTTON_HEIGHT = 55
const StyledButton = styled(Button)<Props>(({ theme, backgroundColor }) => ({
  width: '100%',
  height: `${FOOTER_ACTION_BUTTON_HEIGHT}px`,
  minHeight: `${FOOTER_ACTION_BUTTON_HEIGHT}px`,
  backgroundColor: theme.palette[backgroundColor] || theme.palette.neutral000,
  borderTop: `1px solid ${SEND_FIELD_BORDER_TOP_COLOR}`,
  '&:hover': {
    backgroundColor: theme.palette[backgroundColor] || theme.palette.neutral000,
  },
  borderRadius: 0,
  '& .MuiButton-startIcon': {
    margin: '0 0 0 8px',
  },

  '& .MuiButton-endIcon': {
    marginRight: 'auto',
  },
  ...theme.typography.subtitle1,
}))

export function ActionButton({
  text,
  alertMode,
  onClick,
  startIcon,
  endIcon,
  backgroundColor,
  color,
  className,
}: {
  text: string
  alertMode?: boolean
  startIcon?: JSX.Element
  endIcon?: JSX.Element
  backgroundColor?: PaletteColorOptions
  color?: string
  onClick: () => unknown
  className?: string
}) {
  return (
    <StyledButton
      className={className}
      backgroundColor={backgroundColor}
      sx={{
        color: color ? color : alertMode ? 'error.main' : 'secondary.main',
      }}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {text}
    </StyledButton>
  )
}

ActionButton.defaultProps = {
  alertMode: false,
  startIcon: null,
  endIcon: null,
  backgroundColor: '',
  color: '',
}
